import { defineMessage } from 'services/localization';

export const messages = {
    rangeTypeTextNone: defineMessage('any_date'),
    rangeTypeTextCustom: defineMessage('custom_range'),
    rangeTypeTextToday: defineMessage('today'),
    rangeTypeTextYesterday: defineMessage('yesterday'),
    rangeTypeTextTomorrow: defineMessage('tomorrow'),
    rangeTypeTextThisWeek: defineMessage('this_week'),
    rangeTypeTextLastWeek: defineMessage('last_week'),
    rangeTypeTextNextWeek: defineMessage('next_week'),
    rangeTypeTextThisMonth: defineMessage('this_month'),
    rangeTypeTextLastMonth: defineMessage('last_month'),
    rangeTypeTextNextMonth: defineMessage('next_month'),
    previewTextCustomFull: defineMessage('from_startdate_to_enddate'),
    previewTextCustomStart: defineMessage('from_startdate'),
    previewTextCustomEnd: defineMessage('to_enddate'),
};
